export const supportHandler = () => {
  const email = "support@gainmuscle.app";
  const subject = "Help & Support";

  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;

  window.location.href = mailtoLink;
};
